import { useContext, useEffect, useMemo, useState } from "react";
import {
  Button, Nav, NavItem, NavLink, TabContent, TabPane,
} from "reactstrap";
import "../scss/ResearchInsights.scss";
import { v4 as uuid } from "uuid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowDown,
  faChevronLeft,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import ibexDarkFullIcon from "../../../images/darkLeftBarIcons/ibexDarkFullIcon.png";
import ibexLightFullIcon from "../../../images/lightLeftBarIcons/ibexLightFullIcon.png";
import { toast } from "react-toastify";
import GlobalLoader from "../../../commonfields/GlobalLoader";
import {
  setToSession,
  getFromSession,
  removeFromSession,
} from "../../../helpers/GenericHelpers";
import { LOADER_ENUM, LOADER_OPTIONS } from "../../../models/LoaderModel";
import { MainContext } from "../../../models/MainContext";
import {
  APIS_LIST,
  DOC_AI_MODE_ENUM,
  IConversationModel,
  ITemplateAttributesModel,
  KB_NAMES_ENUM,
  SOLUTION_STUDIO_TABS,
} from "../../../models/ChatModels";
import FileUploadContainers from "../../../components/shared/FileUploadContainers";
import documentAIService from "../../document_ai/documentAIService";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  IDocUserQueryInput,
  IKDBProjectInput,
  IKeyInfoInput,
} from "../../../models/APIModels";
import { RoutesEnum } from "../../../models/RoutesModel";
import LogsModal from "../../../components/shared/LogsModal";
import { IAPIPromptsModel, ProjectTypeEnum, ThemeTypes } from "../../../models/SharedModel";
import { ProjectStatus } from "../../../models/ProjectModel";
import { pushToLog } from "../../../helpers/LogHelpers";
import { ILogsModel } from "../../../models/LogsModel";
import ImgCropComponent from "./ImgCropComponent";
import ChatComponent2 from "../../../components/chat/ChatComponent2";
import researchInsighteService from "../researchInsighteService";
import FileViewer from "../../../commonfields/FileViewer";
import uploadInformation from "../../../images/UploadInformation.png";
import { ThemeContext } from "../../../models/ThemeContext";
import Profile from "../../../components/shared/Profile";
import RawPdfViewer from "../../../commonfields/RawPdfViewer";


import home from "../../../images/darkLeftBarIcons/home.png";
import documentText from "../../../images/darkLeftBarIcons/document-text.png";
import chatIcon from "../../../images/darkLeftBarIcons/chatbox.png";
import configIcon from "../../../images/darkLeftBarIcons/config.png";

import helpCicle from "../../../images/darkLeftBarIcons/help-circle.png";
import settings from "../../../images/darkLeftBarIcons/settings.png";
import logOut from "../../../images/darkLeftBarIcons/log-out.png";

import homeLight from "../../../images/lightLeftBarIcons/home.png";
import documentTextLight from "../../../images/lightLeftBarIcons/document-text.png";
import chatIconLight from "../../../images/lightLeftBarIcons/chatbox.png";
import configIconLight from "../../../images/lightLeftBarIcons/config.png";

import homeChecked from "../../../images/CheckedIcons/home.png";
import documentTextChecked from "../../../images/CheckedIcons/document-text.png";
import chatIconChecked from "../../../images/CheckedIcons/chatbox.png";
import configIconChecked from "../../../images/CheckedIcons/config.png";

import helpCicleLight from "../../../images/lightLeftBarIcons/help-circle.png";
import settingsLight from "../../../images/lightLeftBarIcons/settings.png";
import logOutLight from "../../../images/lightLeftBarIcons/log-out.png";
import Settings from "../../../components/shared/Settings";

const ResearchInsightsPage = () => {
  
  const [formValues, setFormValues] = useState<any>(
    {
      temparature: 0.1,
      chunk_overlap: 250,
      chunk_size: 250
    })
  const { themeName } = useContext(ThemeContext);
  const images:string[]=
   (themeName === ThemeTypes.DARK_THEME) ?
    [home, documentText, chatIcon, helpCicle, settings, logOut, configIcon]
   : [homeLight, documentTextLight, chatIconLight, helpCicleLight, settingsLight, logOutLight, configIconLight]

  const checked = [homeChecked, documentTextChecked, chatIconChecked, configIconChecked];


  const [croppedImage, setCroppedImage] = useState<any>();
  const [croppedImageBlob, setCroppedImageBlob] = useState<any>();
  const [mode, setMode] = useState(DOC_AI_MODE_ENUM.SINGLE_DOCUMENT_MODE); // document ai modes

  const service = new documentAIService();
  const research_insighte_service = new researchInsighteService();

  const { modifyLoaders } = useContext(MainContext);
  const { projectName, version } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const projectType = useMemo(
    () => location?.pathname?.split("/")?.[2],
    [location?.pathname]
  );

  // states
  const [loader, setLoader] = useState(false);
  const [documentFile, setDocumentFile] = useState<any>();
  const [questionsList, setQuestionsList] = useState<any>([]);
  const [conversationList, setConversationList] = useState<
    IConversationModel[]
  >([]);
  const [chatLoader, setChatLoader] = useState(false);
  // const [validationPrompt, setValidationPrompt] = useState(''); // validation Prompt
  const [apiModal, setAPIModal] = useState(false);
  const [validationPrompt, setValidationPrompt] = useState("");
  const [summarizationPrompt, setSummarizationPrompt] = useState("");
  const [logsModal, setLogsModal] = useState(false); // modal to get logs
  const [dontScroll, setDontScroll] = useState(true);
  const [processingTabs, setProcessingTabs] = useState(
    SOLUTION_STUDIO_TABS.DOCUMENT
  );

  const project_main = useMemo(() => {
    const project_main_raw = getFromSession("project_main");
    if (project_main_raw) return JSON.parse(project_main_raw);
    else return "";
  }, []);

  const user_id = getFromSession("user_id");

  // helpers
  const [cropClear, setCropClear] = useState(false);
  const clearImage = () => {
    setCropClear(true);
    setCroppedImage(undefined);
    setCroppedImageBlob(undefined);
  }

  const [testFile, setTestFile] = useState(false);

  const [fileType, setFileType] = useState()
  const handleDocumentChange = (e: any) => {
    setFileType(e[0]?.type)
    const name = `${KB_NAMES_ENUM.KDB_NAME}_${Math.floor(
      100000 + Math.random() * 900000
    )}`;
    setToSession(KB_NAMES_ENUM.KDB_NAME, name);
    setDocumentFile(e);
    setTestFile(true)
    if (e?.length === 0) {
      clearFields();
      clearImage()
      setIsDockUploaded(false);
    }
    // else{
    //   api_status_list()
    // }
  };

  const toggleAPIModal = () => {
    if (!apiModal) {
      save_chat_history(false, 'save_chat_hist')
    }
    setAPIModal((prev) => !prev)
  };

  const toggleLogsModal = () => setLogsModal((prev) => !prev);

  const clearFields = () => {
    setDocumentFile(null);
    resetFields();
    removeFromSession(KB_NAMES_ENUM.KDB_NAME);
  };

  const resetFields = () => {
    setQuestionsList([]);
    setConversationList([]);
    setDontScroll(false);
  };

  // run doc upload and db ingest functions
  const execute = () => {
    ingest_doc_db();
  };

  const apiSuccessCallback = () => navigate(`/${RoutesEnum.LANDING}`);

  const downloadChat = () => {
    const element = document.createElement("a");
    const newData = conversationList?.map(
      (each) =>
        `User: ${each?.prompt?.value
          ?.trimStart()
          ?.trimEnd()}\nResponse: ${each?.answer?.value
            ?.trimStart()
            ?.trimEnd()}\n\n`
    );
    const file = new Blob(newData, { type: "text/plain" });
    element.href = URL.createObjectURL(file);
    element.download = "chat.txt";
    document.body.appendChild(element);
    element.click();
  };

  const handleAPIListSuccess = (values: any) => {
    save_prompts(values);
    toggleAPIModal();
  };

  const handleAPIListCancel = (values: any) => {
    toggleAPIModal();
  };

  const promptsList = useMemo<IAPIPromptsModel[]>(
    () =>
      conversationList
        ?.filter((each) => each?.prompt?.apiCheck)
        ?.map((each2) => ({
          prompt: each2?.prompt?.value,
          status: false,
          type: APIS_LIST.CHATBOT,
        })),
    [conversationList]
  );

  const apisList = useMemo<IAPIPromptsModel[]>(
    () => [
      { type: APIS_LIST.VALIDATION, prompt: validationPrompt, status: false },
      {
        type: APIS_LIST.SUMMARIZATION,
        prompt: summarizationPrompt,
        status: false,
      },
      { type: APIS_LIST.DATA_EXTRACTION, prompt: "default", status: false },
    ],
    [validationPrompt, summarizationPrompt]
  );

  // api calls

  const question_answer = async (prompt: string | any, init = false) => {
    let promptKey: any = 1
    promptKey = Object.keys(prompt)?.find(str => str?.includes('prompt'))
    setChatLoader(true);
    setDontScroll(false);
    const id = uuid();
    const new_conversation = init ? [] : conversationList;
    setConversationList([
      ...new_conversation,
      { id, image: croppedImage, prompt: { value: project_main?.project_status === ProjectStatus.PRODUCTION ? prompt[promptKey] : prompt, time: new Date() } },
    ]);

    //  { id, prompt: { value: (prompt as value), time: new Date() } },

    const kdbName = getFromSession(KB_NAMES_ENUM.KDB_NAME);
    const produtionPayload = {
      project_name: projectName,
      project_type: projectType,
      prompt: promptKey,
      prompt_query: prompt[promptKey],
      fileName: documentFile?.[0]?.path?.split(".")?.[0],
      kdbName,
      version,
      project_id: project_main?.project_id,
    }
    // project_main?.project_status === ProjectStatus.PRODUCTION

    // remove query add prompt as key  --- 
    if (project_main?.project_status === ProjectStatus.PRODUCTION) {
      service
        .docai_get_userquery(produtionPayload as IDocUserQueryInput, project_main?.project_status)
        .then((res) => {
          setConversationList((prev) =>
            prev?.map((each) => {
              if (each?.id === id) {
                return {
                  ...each,
                  answer: {
                    value: res?.data || "Something went wrong",
                    time: new Date(),
                  },
                };
              } else return each;
            })
          );
          setChatInitiate(true)
          const logData: ILogsModel = {
            log_id: uuid(),
            project_id: project_main?.project_id,
            username: user_id,
            solution: projectName || "",
            solution_type: projectType as ProjectTypeEnum,
            api: "/docai_get_userquery",
            prompt,
            result: JSON.stringify(res?.data),
            tags: [],
            violations: [],
            role: "USER",
            time: new Date(),
          };
          save_chat_history(true, 'save_chat_hist');
          pushToLog(logData);
          setChatLoader(false);
        })
        .catch((err) => {
          console.log(err);
          setChatLoader(false);
        });
    } else {
      if ((fileType === 'image/jpeg') || (fileType === 'image/png')) {
        gpt_vision(prompt, id)
      } else {
        if (croppedImage) {
          gpt_vision(prompt, id)
        } else {
          const payload = {
            project_name: projectName,
            project_type: projectType,
            version,
            kdbName,
            project_id: project_main?.project_id,
            reload: 'False',
            prompt_query: prompt[promptKey],
            files: documentFile,
            query: prompt,
            chat_history_op:'save_chat_hist'
          }
          research_insighte_service
            .reserach_get_userquery(payload, id)
            .then((res: any) => {
              clearImage()
              setConversationList((prev) =>
                prev?.map((each) => {
                  if (each?.id === id) {
                    return {
                      ...each,
                      answer: {
                        value: res?.data || "Something went wrong",
                        time: new Date(),
                      },
                    };
                  } else return each;
                })
              );
              setChatInitiate(true)
              const logData: ILogsModel = {
                log_id: uuid(),
                project_id: project_main?.project_id,
                username: user_id,
                solution: projectName || "",
                solution_type: projectType as ProjectTypeEnum,
                api: "/docai_get_userquery",
                prompt: project_main?.project_status === ProjectStatus.PRODUCTION ? prompt[promptKey] : prompt,
                result: JSON.stringify(res?.data),
                tags: [],
                violations: [],
                role: "USER",
                time: new Date(),
              };
              pushToLog(logData);
              setChatLoader(false);
            })
            .catch((err) => {
              console.log(err);
              setChatLoader(false);
            });
        }
      }
    }
  };

  const gpt_vision = (prompt: string, id: any) => {
    const formData = new FormData();
    if ((fileType === 'image/jpeg') || (fileType === 'image/png')) {
      var blobed = new Blob(documentFile, { type: fileType });
      formData.append('files', blobed, 'image.png');
    } else {
      formData.append('files', croppedImageBlob, 'image.png');
    }
    formData.append('query', prompt);
    // const id = uuid();
    console.log('Primary Id ')
    // console.log(id)
    if (croppedImageBlob || (fileType === 'image/jpeg') || (fileType === 'image/png')) {
      service.gpt_vision(formData)
        .then(res => {
          clearImage()
          setConversationList((prev) =>
            prev?.map((each) => {
              if (each?.id === id) {
                return {
                  ...each,
                  answer: {
                    value: res?.data?.analysis_result || "Something went wrong",
                    time: new Date(),
                  },
                };
              } else return each;
            })
          );
          setChatInitiate(true);
          setChatLoader(false);
          setCroppedImage(undefined)
        })
        .catch(err => console.log(err))
    }
  }

  const [chatInitiate, setChatInitiate] = useState(false);
  useEffect(() => {
    if (chatInitiate) {
      save_chat_history(true, 'save_chat_hist');
    }
  }, [chatInitiate && conversationList])

  //
  const ingest_doc_db = async () => {
    const id = uuid();
    const kdbName = getFromSession(KB_NAMES_ENUM.KDB_NAME);
    const payload = {
      // project_name: projectName,
      // project_type: projectType,
      // kdbName,
      // version,
      project_id: project_main?.project_id,
      reload: 'False',
      files: documentFile,
    };
    setLoader(true);
    research_insighte_service
      .reserach_ingest_kdb(payload, id)
      .then(() => {
        const id = uuid();
        setDontScroll(false);
        if (project_main?.project_status === ProjectStatus.PRODUCTION) {
          docai_draft_keyinfo_ext()
          setConversationList([])
        } else {
          //   setQuestionsList([
          //     "1. What is the purpose of Kernel Group Holdings Inc. Units?",
          //     "2. What does the Lear Corporation do for Michigan's Manitou Islands?",
          //     "3. How does the corporation assist with preserving knowledge about the Islands?",
          //     "4. What is the total number of shares that the corporation can issue?",
          //     "5. Who are the incorporators and what are their addresses?"
          // ])
          // top_querys_recommender();
          // auto_template();
          setConversationList([
            {
              id,
              prompt: { value: "Hi", time: new Date() },
              answer: {
                value: "Hello! How may I assist you ?",
                time: new Date(),
              },
            },
          ]);
        }
        setLoader(false);
        const logData: ILogsModel = {
          log_id: uuid(),
          project_id: project_main?.project_id,
          username: user_id,
          solution: projectName || "",
          solution_type: projectType as ProjectTypeEnum,
          api: "/docai_ingest_kdb",
          prompt: "",
          result: "",
          tags: [],
          violations: [],
          role: "USER",
          time: new Date(),
        };
        pushToLog(logData);
      })
      .catch((err) => {
        console.log(err);
        setLoader(false);
      });
  };

  const knowledgebase_summarization = async () => {
    const kdbName = getFromSession(KB_NAMES_ENUM.KDB_NAME);
    const payload = {
      project_name: projectName,
      project_type: projectType,
      kdbName,
      version,
      prompt: summarizationPrompt,
      project_id: project_main?.project_id,
    };
    service
      .docai_kdb_summarization(payload as IKDBProjectInput, project_main?.project_status)
      .then((res) => {
        const logData: ILogsModel = {
          log_id: uuid(),
          project_id: project_main?.project_id,
          username: user_id,
          solution: projectName || "",
          solution_type: projectType as ProjectTypeEnum,
          api: "/docai_kdb_summarization",
          prompt: summarizationPrompt,
          result: res?.data || "",
          tags: [],
          violations: [],
          role: "USER",
          time: new Date(),
        };
        pushToLog(logData);
      })
      .catch((err) => console.log(err));
  };

  const docai_draft_keyinfo_ext = (template?: string) => {
    modifyLoaders(LOADER_ENUM.EXTRACTED_DETAILS, LOADER_OPTIONS.ADD);
    const kdbName = getFromSession(KB_NAMES_ENUM.KDB_NAME);
    const payload = {
      // check for file exist
      // files: documentFile,
      files: ([ProjectStatus.DRAFT, ProjectStatus.WORK_SPACE].includes(project_main?.project_status as ProjectStatus) && isDockUploaded) ? undefined : documentFile,
      version,
      project_id: project_main?.project_id,
      file_name: (project_main?.project_status === ProjectStatus.PRODUCTION || ([ProjectStatus.DRAFT, ProjectStatus.WORK_SPACE].includes(project_main?.project_status as ProjectStatus) && isDockUploaded)) ? documentFile[0]?.path : undefined,
      ...([ProjectStatus.DRAFT, ProjectStatus.WORK_SPACE].includes(project_main?.project_status as ProjectStatus) ? {
        project_name: projectName,
        project_type: projectType,
        template,
        kdbName,
        reload: ([ProjectStatus.DRAFT, ProjectStatus.WORK_SPACE].includes(project_main?.project_status as ProjectStatus) && isDockUploaded) ? "True" : "False",
      } : {})
    };
    service
      .docai_draft_keyinfo_ext(payload as IKeyInfoInput, project_main?.project_status)
      .then((res) => {
        const new_data =
          [ProjectStatus.DRAFT, ProjectStatus.WORK_SPACE].includes(project_main?.project_status as ProjectStatus) && template ?
            modifiedData(res?.data?.[template]) :
            res?.data?.map((each: any) => ({ ...each, dataId: uuid() }))
          ;
        const logData: ILogsModel = {
          log_id: uuid(),
          project_id: project_main?.project_id,
          username: user_id,
          solution: projectName || "",
          solution_type: projectType as ProjectTypeEnum,
          api: "/docai_draft_keyinfo_ext",
          prompt: "",
          result: JSON.stringify(new_data),
          tags: [],
          violations: [],
          role: "USER",
          time: new Date(),
        };
        pushToLog(logData);
        modifyLoaders(LOADER_ENUM.EXTRACTED_DETAILS, LOADER_OPTIONS.REMOVE);
      })
      .catch((err) => {
        console.log(err);
        modifyLoaders(LOADER_ENUM.EXTRACTED_DETAILS, LOADER_OPTIONS.REMOVE);
      });
  };

  const save_prompts = (data: any) => {
    setLoader(true);
    const kdbName = getFromSession(KB_NAMES_ENUM.KDB_NAME);
    const payload = {
      project_name: projectName,
      project_type: projectType,
      kdbName,
      version,
      project_id: project_main?.project_id,
    };

    service
      .save_prompts(payload as IKDBProjectInput, data)
      .then((res) => {
        toggleAPIModal();
        toast.success(res?.data);
        navigate(`${RoutesEnum.LANDING}/${ProjectStatus.PRODUCTION}`);
        setLoader(false);
        const logData: ILogsModel = {
          log_id: uuid(),
          project_id: project_main?.project_id,
          username: user_id,
          solution: projectName || "",
          solution_type: projectType as ProjectTypeEnum,
          api: "/save_prompts",
          prompt: "",
          result: res?.data,
          tags: [],
          violations: [],
          role: "USER",
          time: new Date(),
        };
        pushToLog(logData);
      })
      .catch((err) => {
        console.log(err);
        setLoader(false);
      });
  };

  // This is the state wether the dock already uploaded or not
  const [isDockUploaded, setIsDockUploaded] = useState(false);

  const save_chat_history = (loader = true, command: string) => {
    setChatInitiate(false)
    loader && setLoader(true);
    const kdbName = getFromSession(KB_NAMES_ENUM.KDB_NAME);
    const payload = {
      project_name: projectName,
      project_type: projectType,
      kdbName,
      version,
      project_id: project_main?.project_id,
      chat_history_op: command
    };
    service
      .save_chat_history(payload as IKDBProjectInput, conversationList)
      .then((res) => {
        if (loader) {
          // toast.success(res?.data?.message)
          setLoader(false);
        }
      })
      .catch((err) => {
        console.log(err);
        loader && setLoader(false);
      });
  }

  const summarization = {
    enableSummarization: true,
    knowledgebase_summarization: knowledgebase_summarization,
  };

  const modifiedData = (values: any) => {
    const keys = Object.keys(values);
    return keys?.map((each) => ({
      dataId: uuid(),
      label: each,
      value: values?.[each],
      flags: [],
      roles: [],
      monitor: false,
      workflows: [],
    }));
  };

  // display functions
  const displayLogsModal = useMemo(
    () => <LogsModal logsModal={logsModal} toggleLogsModal={toggleLogsModal} />,
    [logsModal]
  );

  useEffect(() => {
    if (documentFile?.length > 0) {
      if ((documentFile[0]?.type === 'image/png') || (documentFile[0]?.type === 'image/jpg') || (documentFile[0]?.type === 'image/jpeg')) {
      } else {
        if (isDockUploaded == false) {
          execute()
        }
      }
    }
  }, [documentFile])

  useEffect(() => {
    setLoader(true);
    research_saved_project_info();
  }, [])

  const research_saved_project_info = () => {
    setLoader(true);
    const kdbName = getFromSession(KB_NAMES_ENUM.KDB_NAME);
    const payload = {
      // project_name: projectName,
      // project_type: projectType,
      // kdbName,
      // version,
      project_id: project_main?.project_id,
      // user_id:user_id
    };
    service.research_saved_project_info(payload as IKDBProjectInput)
      .then((res) => {
        setToSession(KB_NAMES_ENUM.KDB_NAME, res?.data?.kdb_name)
        if ([ProjectStatus.DRAFT, ProjectStatus.WORK_SPACE].includes(project_main?.project_status as ProjectStatus)) {
          // setDocumentFile([{
          //   ...res?.data?.document,
          //   name: res?.data?.document?.path,
          //   type: res?.data?.document?.path?.split('.')?.[1]
          // }])
          if (res?.data?.file_details?.extracted_info?.file_bytes && res?.data?.file_details?.extracted_info?.file_name) {
            setIsDockUploaded(true)
            setTestFile(true)
            setDocumentFile([{
              value: res?.data?.file_details?.extracted_info?.file_bytes,
              name: res?.data?.file_details?.extracted_info?.file_name,
              path: res?.data?.file_details?.extracted_info?.file_name,
              type: res?.data?.file_details?.extracted_info?.file_name?.split('.')?.[1]
            }])
          }
        }
        if ([ProjectStatus.DRAFT, ProjectStatus.WORK_SPACE].includes(project_main?.project_status as ProjectStatus)) {
          const id = uuid();
          setConversationList(res?.data?.chat_history ? res?.data?.chat_history : [
            {
              id,
              prompt: { value: "Hi", time: new Date() },
              answer: {
                value: "Hello! How may I assist you ?",
                time: new Date(),
              },
            },
          ])
        }
        setLoader(false);
        setSummarizationPrompt(res?.data?.summarization_prompt?.value)
        setValidationPrompt(res?.data?.validation_prompt?.value)

        // Setting Extracted info
        //   if(res?.data?.extracted_info) {
        //     let template = Object.keys(res?.data?.extracted_info && Object.values(res?.data?.extracted_info)[0]  ) [0]
        //     const new_data = [ProjectStatus.DRAFT, ProjectStatus.WORK_SPACE].includes(project_main?.project_status as ProjectStatus) && template ?
        //       modifiedData(res?.data?.extracted_info?.value?.[template]) : res?.data?.extracted_info?.value?.map((each: any) => ({ ...each, dataId: uuid() }))
        //   ;        
        //   setExtractedData(new_data)
        // }
      })
      .catch((err) => {
        setIsDockUploaded(false)
        console.log(err);
        setLoader(false);
      });
  }

  const documentOptionPanel = () => {
    return (
      <div className="document-input-panel">
            <FileUploadContainers
              files={documentFile}
              handleFileChange={handleDocumentChange}
              label=""
              btnlabel={
                <>
                  <FontAwesomeIcon icon={faPlus} /> Add Document
                </>
              }
              displayFilesContent={true}
              displayInput={!documentFile || documentFile?.length < 1}
              accept={{
                "application/pdf": [".pdf"],
                "image/jpeg": [".jpeg", ".jpg"],
                "image/png": [".png"],
              }}
              maxFiles={
                mode === DOC_AI_MODE_ENUM.SINGLE_DOCUMENT_MODE ? 1 : 20
              }
            />
      </div>
    )
  }

  const userName = getFromSession('user_name');

  const addConfig = (data: any) => {
    const finalData = { ...data, project_id: project_main?.project_id }
    service?.add_project_configuration(finalData).then((response: any) => {
      response?.data && toast.success(response?.data);
      // toggleSettingsModal()
    }).catch((error: any) => {
      console.log(error)
      toast.error('something went wrong')
    })
  }

  const getConfig = (projectId: string) => {
    const data = { project_id: projectId }
    service?.get_project_configuration_details(data).then((res: any) => {
      const resdata = {
        "chunk_overlap": res?.data?.chunk_overlap,
        "chunk_size": res?.data?.chunk_size,
        "model_name": res?.data?.model_name,
        "open_ai_key": res?.data?.open_ai_key,
        "temperature": res?.data?.temperature
      }
      setFormValues(resdata);
    }).catch((error: any) => {
      console.log(error)
    })
  }

  useEffect(() => {
    getConfig(project_main?.project_id)
  }, [project_main?.project_id])
  return (
    <>
      {loader ? <GlobalLoader /> : <></>}
      <div className={`solition-studio ${themeName === ThemeTypes?.BLUE_THEME ? 'bright' :''}`}>
        <div className='left-menu'>
          <div className='header'>
            <img src={themeName === ThemeTypes?.BLUE_THEME ? ibexLightFullIcon : ibexDarkFullIcon} alt='Ibex' />
          </div>
          <div className='menu'>
            <div className='top-menu'>
              <Nav pills>
                <div className='item home'>
                  <NavItem>
                    <NavLink
                      className={
                        processingTabs === SOLUTION_STUDIO_TABS.DASHBOARD
                          ? "active"
                          : ""
                      }
                      // onClick={() => setProcessingTabs(SOLUTION_STUDIO_TABS.DASHBOARD)}
                      onClick={() => navigate(`${RoutesEnum.LANDING}`)}
                    >
                      <img src={images[0]} alt="Home" /><div className='text'>Dashboard </div>
                    </NavLink>
                  </NavItem>
                </div>
                <div className='item'>
                  <NavItem>
                    <NavLink
                      className={
                        processingTabs === SOLUTION_STUDIO_TABS.DOCUMENT
                          ? "active"
                          : ""
                      }
                      onClick={() => setProcessingTabs(SOLUTION_STUDIO_TABS.DOCUMENT)}
                    >
                      <img src={processingTabs === SOLUTION_STUDIO_TABS.DOCUMENT ? checked[1] : images[1]} alt="Home" /><div className='text'>Document</div>
                    </NavLink>
                  </NavItem>
                </div>
                <div className='item'>
                  <NavItem>
                    <NavLink
                      className={
                        processingTabs === SOLUTION_STUDIO_TABS.CHATBOT
                          ? "active"
                          : ""
                      }
                      onClick={() => setProcessingTabs(SOLUTION_STUDIO_TABS.CHATBOT)}
                    >
                      <img src={processingTabs === SOLUTION_STUDIO_TABS.CHATBOT ? checked[2] : images[2]} alt="Home" /><div className='text'>ChatAi</div>
                    </NavLink>
                  </NavItem>
                </div>
                {/* <div className='item'>
                    <NavItem>
                      <NavLink
                        className={
                          processingTabs === SOLUTION_STUDIO_TABS.CONFIGURE_PREFERENCES
                            ? "active"
                            : ""
                        }
                        onClick={() => setProcessingTabs(SOLUTION_STUDIO_TABS.CONFIGURE_PREFERENCES)}
                      >
                        <img src={processingTabs === SOLUTION_STUDIO_TABS.CONFIGURE_PREFERENCES ? checked[3] :images[6]} alt="Home" /><div className='text'>Configure&nbsp;Preferences</div>
                      </NavLink>
                    </NavItem>
                </div> */}
              </Nav>
            </div>
            <div className='footer-menu'>
              <div className='item'><img src={images[3]} alt="Home" /><div className='text'>Help</div></div>
              <div className='item'><img src={images[4]} alt="Home" /><div className='text'>Settings</div></div>
              <div className='item'><img src={images[5]} alt="Home" /><div className='text'>Logout</div></div>
              {/* <div className='item'><img className='iconImg' src={user} alt="Home" /><div className='text'>Username</div></div> */}
              <div className='item'>
                      {/* <img className='iconImg' src={user} alt="Home"/> */}
                      <Profile />
                    <div className='text'>{userName}</div></div>
            </div>
          </div>
        </div>
        <div className='page-body'>
          <div className='project-header'>
            <div>{projectName}</div>
          </div>
          <TabContent activeTab={processingTabs}>
            <TabPane tabId={SOLUTION_STUDIO_TABS.CHATBOT} >
              <div className="pane-content">
                <div className="child child5">
                  <ImgCropComponent
                    setCroppedImage={setCroppedImage}
                    setCroppedImageBlob={setCroppedImageBlob}
                    gpt_vision={gpt_vision}
                    cropClear={cropClear}
                    setCropClear={setCropClear}
                    testFile={testFile}
                    setTestFile={setTestFile}
                    documentFile={documentFile}
                    documentOptionPanel={documentOptionPanel}
                  />
                </div>
                <div className="child">
                <div className={`info-container2 ${mode === DOC_AI_MODE_ENUM.SINGLE_DOCUMENT_MODE ? "" : "info-grow"
                  }`}
                >
                  <div className="info-analysis-container">
                    <div className="info-analysis-box">
                      <div className="info-analysis-title">iBex Chat Assistant</div>
                      <div className="info-right">
                        {conversationList?.length > 0 ? (
                          <div className="info-download-btn">
                            <Button
                              outline
                              color="info"
                              onClick={downloadChat}
                              disabled={conversationList?.length < 1}
                            >
                              <FontAwesomeIcon icon={faArrowDown} /> Chat Download
                            </Button>
                          </div>
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>

                    <div className="info-analysis-box">
                      <ChatComponent2
                        conversationList={conversationList}
                        question_answer={question_answer}
                        summarization={summarization}
                        questionsList={questionsList}
                        chatLoader={chatLoader}
                        croppedImage={croppedImage}
                        clearImage={clearImage}
                        setConversationList={setConversationList}
                        dontScroll={dontScroll}
                        setDontScroll={setDontScroll}
                        displayCheck={true}
                        project_main={project_main}
                      />
                    </div>

                  </div>
                </div>
                </div>
              </div>
            </TabPane>
            <TabPane tabId={SOLUTION_STUDIO_TABS.DOCUMENT}>
              <div className='pane-content'>
                <div className='child child3'>
                {documentFile!==undefined ?? <div className='header'>Document Viewer</div>}
                  <div className='document'>

                    <FileUploadContainers
                      files={documentFile}
                      handleFileChange={handleDocumentChange}
                      btnlabel={
                        <div className='labels'>
                          <img src={uploadInformation} alt="upload" /><div className='text'><u>Click to Upload</u><br></br>or
                            <br></br>drag and drop</div>
                        </div>
                      }
                      displayFilesContent={true}
                      displayInput={!documentFile || documentFile?.length < 1}
                      accept={{
                        "application/pdf": [".pdf"],
                        "image/jpeg": [".jpeg", ".jpg"],
                        "image/png": [".png"],
                      }}
                      maxFiles={
                        mode === DOC_AI_MODE_ENUM.SINGLE_DOCUMENT_MODE ? 1 : 20
                      }
                    />
                    {documentFile ? (
                      <>
                        {/* <FileViewer file={documentFile?.[0]} showPreview={true} /> */}
                        <RawPdfViewer file={documentFile?.[0]} />
                      </>
                    ) : (
                      <div className="not-found">No Document to display</div>
                    )}
                  </div>
                </div>
              </div>
            </TabPane>
            <TabPane tabId={SOLUTION_STUDIO_TABS.CONFIGURE_PREFERENCES}>
                <div className='pane-content'>
                  <div className='child child3'>
                    <Settings   
                      // toggleSettingsModal={toggleSettingsModal}
                      formValues={formValues}
                      setFormValues={setFormValues}
                      addConfig={addConfig}
                    />
                  </div>
                </div>
              </TabPane>
          </TabContent>
        </div>
      </div>
    </>
  );
};

export default ResearchInsightsPage;
